module.exports = __webpack_public_path__ + "static/media/IMG_9829.51bbc48b.jpg";